import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { ModalResultFinalTeam } from '../../components/common/ModalResultFinalTeam';
import { audiosAssets } from '../../assets/audio';

export const SubtopicFinalTeam2 = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 10);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded])
	return (
		<>
			<ModalResultFinalTeam
				title='¡Felicidades!'
				subTitle='¡Concluiste el Tema 2!'
				buttonText='Iniciar Tema 3'
				actionButton={() => {
					window.location.href = "/home3/tema3/introduction";
				}} actionBack={() => {
					window.location.href = "/home1";
				}}

			/>
		</>
	)
}


